
import DialogMixins from '@/mixins/DialogMixins';
import WidgetMixins from '@/mixins/WidgetMixins';
import { loadWidget } from '@/utils/helpers';
import Component, { mixins } from 'vue-class-component';
import { Getter, namespace } from 'vuex-class';
import { ICreditBalance } from '@/types/types';
import { checkMomoPaymentStatus } from '@/services/payments.service';

@Component({
  name: 'StatusCheck',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
  },
})
export default class StatusCheck extends mixins(WidgetMixins, DialogMixins) {
  @Getter('getCreditBalance') creditBalance!: ICreditBalance;

  // Status check state
  referenceId = '';
  status = '';
  amount: number | null = null;
  isChecking = true;
  errorMessage = '';
  checkCount = 0;
  checkInterval = 15000; // 15 seconds

  // Used for interval clearing
  statusCheckTimer: number | null = null;

  created() {
    // Get reference ID from query parameters
    this.referenceId = this.$route.query.referenceId as string;

    if (!this.referenceId) {
      this.errorMessage = 'No reference ID provided.';
      this.status = 'FAILED';
      this.isChecking = false;
      return;
    }

    // Start checking payment status
    this.checkPaymentStatus();
  }

  beforeDestroy() {
    // Clear any existing timer
    if (this.statusCheckTimer) {
      clearTimeout(this.statusCheckTimer);
    }
  }

  checkPaymentStatus() {
    this.isChecking = true;

    checkMomoPaymentStatus(this.referenceId)
      .then((response: any) => {
        if (response.data && response.data.data) {
          const paymentData = response.data.data;
          this.status = paymentData.paymentStatus;

          if (paymentData.amount) {
            this.amount = paymentData.amount;
          }

          // If payment is successful
          if (this.status === 'SUCCESSFUL') {
            this.$store.dispatch('checkCreditBalance', null, { root: true });
          }
        } else {
          this.errorMessage =
            response.data?.message || 'Unable to retrieve payment status';
          this.status = 'PENDING';
        }
      })
      .catch((error) => {
        console.error('Error checking payment status:', error);
        this.errorMessage = 'Failed to check payment status';
        this.status = 'PENDING';
      })
      .finally(() => {
        this.checkCount += 1;
        this.isChecking = false;

        // If status is still pending and we haven't checked twice yet
        if (this.status === 'PENDING' && this.checkCount < 2) {
          this.statusCheckTimer = window.setTimeout(() => {
            this.checkPaymentStatus();
          }, this.checkInterval);
        }
      });
  }

  goToDashboard() {
    this.$router.push('/dashboard');
  }

  tryAgain() {
    this.$router.push('/payments/momo');
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'SUCCESSFUL':
        return 'kx-status--success';
      case 'FAILED':
        return 'kx-status--failed';
      case 'PENDING':
        return 'kx-status--pending';
      default:
        return 'kx-status--info';
    }
  }
}
